export default __webpack_public_path__ + "static/media/data-home-pic1.86d5e41d.png";